import React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
import svg from './svg';

const HeartSvg = type => (
    <svg width="1em" height="1em" fill="currentColor" viewBox="0 0 1024 1024">
        {svg[type]}
    </svg>
);

export default ({ type, className, style }) => (
    <Icon style={style} className={className} component={() => HeartSvg(type)} />
);
